import Swiper from 'swiper'
import 'swiper/css'

export class FacilityCardSlider {
  constructor() {
    if (document.querySelector('.js-facility_card_slider') === null) return
    const sliders = document.querySelectorAll('.js-facility_card_slider')
    sliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true,
        setWrapperSize: true,
        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      })
    })
  }
}
